var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-intro-text"},[_c('p',{staticClass:"intro-text",domProps:{"innerHTML":_vm._s(_vm.candidate.introText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }